<template>
	<!-- Navbar start -->
	<navbar-element></navbar-element>
	<!-- Navbar end -->

	<!-- Rendered view start -->
	<home-view></home-view>
	<!-- Rendered view end -->

	<!-- Footer start -->
	<footer-element></footer-element>
	<!-- Footer end -->
</template>

<script>
import { createApp } from 'vue';
import App from './App.vue';
import VueSmoothScroll from 'vue3-smooth-scroll'
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';
import HomeView from '@/HomeView.vue';

const app = createApp(App).use(VueSmoothScroll)
app.mount('#app')

export default {
	components: {
		HomeView,
		FooterElement,
		NavbarElement
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&family=Poppins:wght@300;400;500;600&display=swap');

:root {
	--header-font: 'Quicksand', cursive;
	--body-font: 'Poppins', sans-serif;
	--section-color-1: #f7fee7; /* lime-50 */
	--section-color-2: #faf5ff; /* purple-50 */
}

h1, h2, h3, h4, h5, h6 {
	font-family: var(--header-font);
}

body, p, span, div {
	font-family: var(--body-font);
}
</style>
